// app/javascript/controllers/turbo_delete_controller.js
// Sends a DELETE request via fetch and processes the turbo_stream response.
// Use this instead of data-turbo-method="delete" when the link lives inside
// a form that has data-turbo="false" (which disables Turbo for descendants).
import {Controller} from "stimulus";

export default class extends Controller {
    destroy(event) {
        event.preventDefault();

        const url = this.element.dataset.turboDeleteUrlValue;
        if (!url) {
            console.error("Turbo delete: missing data-turbo-delete-url-value");
            return;
        }

        const confirmMsg = this.element.dataset.turboDeleteConfirmValue;
        if (confirmMsg && !confirm(confirmMsg)) return;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

        fetch(url, {
            method: "DELETE",
            headers: {
                "X-CSRF-Token": csrfToken,
                "Accept": "text/vnd.turbo-stream.html"
            }
        }).then(response => {
            if (response.ok) return response.text();
            throw new Error("Delete failed");
        }).then(html => {
            if (html && html.includes("<turbo-stream")) {
                Turbo.renderStreamMessage(html);
            }
        }).catch(error => {
            console.error("Turbo delete failed:", error);
        });
    }
}
